//Imports
import {
	SEASON_COLLECTION,
	SERIES_COLLECTION,
	USER_MEDIA_METADATA_COLLECTION
} from '../../../AppConstants/CollectionConstants';
import { SEASON_FETCH_LIMIT } from '../../../AppConstants/Constants';
import { Video_States } from '../../../AppConstants/TypeConstants';

// Firebase
import { database, firestore } from '../../../firebase/firebase';
import SpeakerManager from '../../Speakers';

export const getSeasonById = async ({ user = null, seasonId }, cb = () => {}) => {
	try {
		const docRef = firestore.collection(SEASON_COLLECTION).doc(seasonId);
		const doc = await docRef.get();
		if (!doc.exists) {
			const error = {
				code: 'NotValidId',
				message: 'No SeasonId Found'
			};
			throw error;
		}
		let _data = doc.data();
		if (_data.status !== Video_States.READY) {
			throw new Error('Season Not ready');
		}
		if (_data.speakers && _data.speakers.length) {
			let res = await SpeakerManager._get.getExtraDataFromRDB('speakers', _data.speakers, 'name');
			_data['speakernames'] = res;
		}
		if (user) {
			let isUnlockedForUser = await checkSeasonUnlockedForUser(user.uid, _data.id);
			_data['isUnlockedForUser'] = isUnlockedForUser;
		} else {
			_data['isUnlockedForUser'] = false;
		}

		const payload = {
			id: seasonId,
			data: _data
		};

		if (cb) {
			cb(payload.data);
		}

		return payload.data;
	} catch (error) {
		if (cb) {
			cb(false);
		}
		console.error('Error SEASON:: ', error);
		throw error;
	}
};

const checkSeasonUnlockedForUser = async (userId = '', seasonId = '') => {
	try {
		let unlocked = false;
		if (!userId || !seasonId) {
			return unlocked;
		}
		let docRef = await database.ref(`unlocked/${userId}/${seasonId}`).once('value');

		if (!docRef.exists()) {
			return unlocked;
		} else {
			let _data = docRef.val();
			if (_data.code && _data.timestamp) {
				unlocked = true;
				return unlocked;
			}
		}
	} catch (error) {
		console.error('Error :: ', error);
		return false;
	}
};

// 1. For Doctor Pushpendra
/**
 * Add video tags to series and season and creation of an episode
 * Update existing episode's seasons and series
 * Fetch Seasons based on speciality in seasons
 */
// old
// const fetchSeasonsByUserSpeciality = async ({
//   speciality,
//   lastDocRef = null,
//   limit = SEASON_FETCH_LIMIT,
//   ignoreLimit = false,
//   data = [],
// }) => {
//   try {
//     if (!speciality) {
//       return [];
//     }
//     let docRef = firestore
//       .collection(SEASON_COLLECTION)
//       .where("speciality", "array-contains", speciality.toLowerCase());

//     if (!ignoreLimit) docRef = docRef.limit(limit);

//     // Pagination
//     if (lastDocRef) docRef = docRef.startAfter(lastDocRef);
//     const query = await docRef.get();

//     let _data = data;
//     if (query.empty) {
//       return {
//         data: _data,
//         lastDocRef: null,
//       };
//     }

//     // Updating last docRef
//     let _lastDocRef = query.docs[query.docs.length - 1];

//     query.docs.forEach((doc) => {
//       _data.push(doc.data());
//     });
//     const payload = {
//       data: _data,
//       lastDocRef: _lastDocRef,
//     };
//     return payload;
//   } catch (error) {
//     console.error("Error :: ", error);
//     throw error;
//   }
// };
const fetchSeasonsByUserSpeciality = async () => {
	try {
		let docRef = await database.ref('backstageV2/ForDrAsPerSpeciality').once('value');
		if (!docRef.exists()) {
			return [];
		} else {
			return {
				data: docRef.val(),
				lastDocRef: null
			};
			//   let seasonIds = docRef.val();

			//   let promiseArr = [];
			//   for (let seasonId of seasonIds) {
			//     promiseArr.push(
			//       firestore.collection(SEASON_COLLECTION).doc(seasonId).get()
			//     );
			//   }
			//   const resolved = await Promise.allSettled(promiseArr);

			//   let returnData = [];
			//   for (let doc of resolved) {
			//     if (doc.status === "fulfilled") {
			//       if (
			//         doc.value.exists &&
			//         doc.value.data().status === Video_States.READY
			//       ) {
			//         returnData.push(doc.value.data());
			//       }
			//     }
			//   }

			//   const payload = {
			//     data: returnData,
			//     lastDocRef: null,
			//   };
			//   return payload;
		}
	} catch (error) {
		console.error('Error :: ', error);
		throw error;
	}
};

// 2. Continue Watching
/**
 *  Fetch last 5 - 10 episodes from usermediametadata sort by updatetimestamp desc
 */
const getContinueWatching = async ({
	uid,
	lastDocRef = null,
	limit = SEASON_FETCH_LIMIT,
	ignoreLimit = false,
	data = []
}) => {
	try {
		let docRef = firestore
			.collection(USER_MEDIA_METADATA_COLLECTION)
			.where('userId', '==', uid)
			.where('targetType', '==', 'series')
			.orderBy('updatedTimestamp', 'desc');

		if (!ignoreLimit) docRef = docRef.limit(limit);

		if (lastDocRef) docRef = docRef.startAfter(lastDocRef);
		const query = await docRef.get();

		
		if (query.empty) {
			return {
				data: data,
				lastDocRef: null
			};
		}

		// Updating last docRef
		let _lastDocRef = query.docs[query.docs.length - 1];
		let _data = data.concat(query.docs.map((doc) => doc.data().seasonId));
		_data = [...new Set(_data)];

		let returnData = await Promise.all(
			_data.map(async (seasonId) => {
				let seasonRef = await firestore.collection(SEASON_COLLECTION).doc(seasonId).get();
				return seasonRef.exists && seasonRef.data().status === Video_States.READY
					? seasonRef.data()
					: null;
			})
		);
        returnData=returnData.filter((item)=> item!==null)
		const payload = {
			data: returnData,
			lastDocRef: _lastDocRef
		};
		return payload;
	} catch (error) {
		console.error(error);
		throw error;
	}
};

// 4. Recently Added
/**
 * Based on timestamp - Show Seasons
 */
const recentlyAddedSeasons = async ({
	lastDocRef = null,
	limit = SEASON_FETCH_LIMIT,
	ignoreLimit = false,
	data = []
}) => {
	try {
		let docRef = firestore
			.collection(SEASON_COLLECTION)
			.where('status', '==', Video_States.READY)
			.orderBy('timestamp', 'desc');
		if (!ignoreLimit) docRef = docRef.limit(limit);

		// Pagination
		if (lastDocRef) docRef = docRef.startAfter(lastDocRef);
		const query = await docRef.get();

		let _data = data;
		if (query.empty) {
			return {
				data: _data,
				lastDocRef: null
			};
		}

		// Updating last docRef
		let _lastDocRef = query.docs[query.docs.length - 1];

		query.docs.forEach((doc) => {
			_data.push(doc.data());
		});

		const payload = {
			data: _data,
			lastDocRef: _lastDocRef
		};
		return payload;
	} catch (error) {
		console.error('Error :: ', error);
		throw error;
	}
};

// old
// 6. Most Viewed Shows - seasons
/**
 * Backstage - replace videos with seasons
 */
// const fetchMostViewedSeasons = async () => {
//   try {
//     let docRef = await database
//       .ref("backstage/MostWatchedSeasons")
//       .once("value");
//     if (!docRef.exists()) {
//       return {
//         data: [],
//         lastDocRef: null,
//       };
//     } else {
//       let seasonIds = docRef.val();

//       let returnData = [];
//       seasonIds.forEach(async (seasonId) => {
//         let seasonRef = await firestore
//           .collection(SEASON_COLLECTION)
//           .doc(seasonId)
//           .get();
//         if (seasonRef.exists) {
//           returnData.push(seasonRef.data());
//         }
//       });

//       const payload = {
//         data: returnData,
//         lastDocRef: null,
//       };
//       return payload;
//     }
//   } catch (error) {
//     console.error("Error :: ", error);
//     throw error;
//   }
// };

const fetchMostViewedSeasons = async () => {
	try {
		let docRef = await database.ref('backstageV2/MostViewedSeasons').once('value');
		if (!docRef.exists()) {
			return [];
		} else {
			return {
				data: docRef.val(),
				lastDocRef: null
			};
			// let seasonIds = docRef.val();

			// const promiseArr = [];
			// for (let seasonId of seasonIds) {
			// 	promiseArr.push(firestore.collection(SEASON_COLLECTION).doc(seasonId).get());
			// }

			// const resolved = await Promise.allSettled(promiseArr);

			// let returnData = [];
			// for (let doc of resolved) {
			// 	if (doc.status === 'fulfilled') {
			// 		if (doc.value.exists && doc.value.data().status === Video_States.READY) {
			// 			returnData.push(doc.value.data());
			// 		}
			// 	}
			// }

			// const payload = {
			// 	data: returnData,
			// 	lastDocRef: null
			// };
			// return payload;
		}
	} catch (error) {
		console.error('Error :: ', error);
		throw error;
	}
};

// trending series
const getTrendingSeries = async () => {
	try {
		let docRef = await database.ref('backstageV2/TopViewedShowsLastMonth').once('value');
		if (!docRef.exists()) {
			return [];
		} else {
			return {
				data: docRef.val(),
				lastDocRef: null
			};
			// let seriesIds = docRef.val();

			// const promiseArr = [];
			// for (let seriesId of seriesIds) {
			// 	promiseArr.push(firestore.collection(SERIES_COLLECTION).doc(seriesId).get());
			// }

			// const resolved = await Promise.allSettled(promiseArr);

			// let returnData = [];
			// for (let doc of resolved) {
			// 	if (doc.status === 'fulfilled') {
			// 		if (doc.value.exists && doc.value.data().status === Video_States.READY) {
			// 			returnData.push(doc.value.data());
			// 		}
			// 	}
			// }

			// const payload = {
			// 	data: returnData,
			// 	lastDocRef: null
			// };

			// return payload;
		}
	} catch (error) {
		console.error('Error :: ', error);
		throw error;
	}
};

const get = {
	getSeasonById,
	recentlyAddedSeasons,
	getContinueWatching,
	fetchSeasonsByUserSpeciality,
	fetchMostViewedSeasons,
	getTrendingSeries,
	checkSeasonUnlockedForUser
};

export default get;
